import { render, staticRenderFns } from "./MarketTag.vue?vue&type=template&id=66dfa154&scoped=true&"
import script from "./MarketTag.vue?vue&type=script&lang=js&"
export * from "./MarketTag.vue?vue&type=script&lang=js&"
import style0 from "./MarketTag.vue?vue&type=style&index=0&id=66dfa154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfa154",
  null
  
)

export default component.exports